<template>
  <el-button icon="el-icon-printer" :disabled="disabled || printing" :loading="printing" @click="print">打印审批单</el-button>
</template>
<script>
import { financeDetail } from '@/api/crm/financeApplication'
import { expenseDetail } from '@/api/crm/expense'
import { queryWorkOrder } from '@/api/crm/contract'
import { ledgerDetail } from '@/api/crm/oaLedger'
const { buildFinanceApprovalPrint, buildFinanceApprovalSnapshotPrint, printFinanceApproval } = require('@/utils/financeApprovalPrint')
export default {
  name: 'FinanceApprovalPrintButton',
  props: { type: { type: String, required: true }, applicationId: [Number, String], ledgerWorkOrderId: [Number, String], disabled: Boolean },
  data() { return { printing: false } },
  beforeDestroy() { this.destroyed = true },
  methods: {
    async print() {
      if (this.disabled || this.printing) return
      const type = this.type, id = this.applicationId, ledgerId = this.ledgerWorkOrderId
      this.printing = true
      try {
        if (ledgerId) {
          // The ledger prints the selected submission's immutable snapshot through its read-only API.
          const approval = (await ledgerDetail(ledgerId)).data
          if (this.destroyed || type !== this.type || String(ledgerId) !== String(this.ledgerWorkOrderId)) return
          await printFinanceApproval(buildFinanceApprovalSnapshotPrint({ type, approval, workOrderId: ledgerId }))
          return
        }
        const detail = (await (type === 'EXPENSE' ? expenseDetail(id) : financeDetail(id))).data
        const application = type === 'EXPENSE' ? detail.claim : detail.application
        if (!application || !application.workOrderId) throw Error('请先提交审批，再打印审批单')
        const approval = (await queryWorkOrder({ workOrderId: application.workOrderId, needFormInfo: false })).data
        if (this.destroyed || type !== this.type || String(id) !== String(this.applicationId)) return
        await printFinanceApproval(buildFinanceApprovalPrint({ type, detail, approval }))
      } catch (e) {
        if (!this.destroyed) this.$message.error(e.message || '审批单加载失败，请刷新后重试')
      } finally { this.printing = false }
    }
  }
}
</script>
